import { styled } from '@material-ui/core';
import { SRoundedContainer } from '@setvi/shared/components';

export const EnhancedCardLoadingContainer = styled(SRoundedContainer)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  height: '100%',
  boxSizing: 'border-box'
});
